import { Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { History as HistoryIcon } from "lucide-react";
import { boardHistoryMonthsQuery } from "@/lib/history-queries";
import { monthSlug, monthYearLabel } from "@/lib/history";
import { useT } from "@/i18n";

/** "View previous rankings" strip shown under a live board. */
export function BoardHistoryLinks({ boardSlug }: { boardSlug: string }) {
  const { t, locale } = useT();
  const { data } = useQuery(boardHistoryMonthsQuery(boardSlug));
  const months = data ?? [];
  if (months.length === 0) return null;

  return (
    <section className="mt-10">
      <h2 className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-widest text-muted-foreground">
        <HistoryIcon className="size-4 text-primary" />
        {t("history.pastRankings")}
      </h2>
      <ul className="mt-3 flex flex-wrap gap-2">
        {months.map((s) => (
          <li key={s.id}>
            <Link
              to="/history/$year/$month/$board"
              params={{
                year: String(s.year),
                month: monthSlug(s.month),
                board: s.category_slug,
              }}
              search={{ page: undefined }}
              className="inline-block rounded-full border border-border px-3 py-1.5 text-sm capitalize transition-colors hover:border-primary/50 hover:text-primary"
            >
              {monthYearLabel(s.month, s.year, locale)}
            </Link>
          </li>
        ))}
        <li>
          <Link
            to="/history"
            className="inline-block rounded-full border border-dashed border-border px-3 py-1.5 text-sm text-muted-foreground hover:text-foreground"
          >
            {t("history.backToHistory")}
          </Link>
        </li>
      </ul>
    </section>
  );
}
